
import { fetchData } from './fetch';
import API from './api';




/**
* 统计当前登录用户未读消息数量（按channel分别统计）
* @param params.channel 消息频道，多个用逗号隔开，缺省时查询全部消息类型
* 0：首页消息
* 1：点赞消息
* 2：回复消息
* 3：系统消息
*/
export function getUnReadCount(data) {
    return fetchData(API.GET_UNREAD_COUNT.url, API.GET_UNREAD_COUNT.type, data);
}
